<template>
    <psi-form-layout-section
        title="Program Address"
        :icon="$config('icons.address')"
        btn-label="Save Address"
        :btn-icon="$config('icons.address')"
        :btn-disabled="$_.get(program, 'id', 0) === 0"
        @section-save="save"
        :loading="sectionLoading.address"
    >
        <psi-form-section
            :ref="section.ref"
            :value="modelData"
            :name="section.name"
            label=""
            :fields="fields"
            color="secondary"
            @input="update"
        ></psi-form-section>
    </psi-form-layout-section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name: "program-address",
    components: {},
    props: {
        id: {
            type: String,
            required: true,
        },
        program: {
            type: Object,
            required: true,
        },
        sectionLoading: {
            type: Object,
            required: false,
            default: () => {
                return {
                    address: false,
                };
            },
        },
    },
    data() {
        return {
            section: {
                name: "input-program-address",
                ref: "program-address",
            },
            modelData: {},
        };
    },
    computed: {
        ...mapGetters("Screens", ["states"]),
        fields() {
            return [
                {
                    type: "text",
                    name: "street",
                    key: "street",
                    label: "Street",
                    icon: this.$config("icons.address"),
                    required: true,
                },
                {
                    type: "text",
                    name: "unit",
                    key: "unit",
                    label: "Unit",
                    icon: this.$config("icons.unit"),
                    required: false,
                },
                {
                    type: "text",
                    name: "city",
                    key: "city",
                    label: "City",
                    required: true,
                    icon: this.$config("icons.city"),
                },
                {
                    type: "select",
                    name: "state",
                    key: "state",
                    label: "State",
                    required: true,
                    items: this.states,
                    "item-text": "name",
                    "item-value": "abbrev",
                    loading: this.dataLoading,
                    icon: this.$config("icons.state"),
                },
                {
                    type: "text",
                    name: "zip",
                    key: "zip",
                    required: true,
                    label: "Zip",
                    icon: this.$config("icons.zip"),
                },
            ];
        },
    },
    watch: {
        program: {
            immediate: true,
            handler(program) {
                if (Object.keys(program).length > 0) {
                    this.modelData = program.address;
                }
            },
        },
    },
    methods: {
        ...mapActions("Screens", ["getStates"]),
        update() {},
        save() {
            if (this.$refs[this.section.ref].validate()) {
                this.$emit("update", this.id, {
                    id: this.program.id,
                    address: this.modelData,
                });
            }
        },
    },
    mounted() {
        this.getStates();
    },
};
</script>

<style scoped>
</style>